import { render, staticRenderFns } from "./TermsOfServiceView.vue?vue&type=template&id=f5016dd6&scoped=true"
import script from "./TermsOfServiceView.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceView.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceView.vue?vue&type=style&index=0&id=f5016dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5016dd6",
  null
  
)

export default component.exports